// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedConnectionsAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 2C9.78513 2 11.3882 2.77958 12.4873 4.01687 12.8969 3.46187 13.5306 3.08235 14.2549 3.01187 12.789 1.17614 10.5318 0 8 0 6.6795 0 5.43373.319935 4.33596.886519 4.91796 1.25518 5.33721 1.8576 5.46172 2.56178 6.23262 2.20134 7.0928 2 8 2ZM0 8C0 6.6795.319935 5.43373.886519 4.33596 1.25518 4.91796 1.8576 5.33721 2.56178 5.46172 2.20134 6.23262 2 7.0928 2 8 2 9.78513 2.77958 11.3882 4.01687 12.4873 3.46187 12.8969 3.08235 13.5306 3.01187 14.2549 1.17614 12.789 0 10.5318 0 8ZM4.5 3C4.5 3.82843 3.82843 4.5 3 4.5 2.17157 4.5 1.5 3.82843 1.5 3 1.5 2.17157 2.17157 1.5 3 1.5 3.82843 1.5 4.5 2.17157 4.5 3ZM5.34424 13.008C5.65044 13.8704 6.14829 14.642 6.78656 15.2716 6.52427 15.708 6.04623 16 5.5 16 4.67157 16 4 15.3284 4 14.5 4 13.7242 4.58901 13.0859 5.34424 13.008ZM15.2716 6.78656C14.642 6.14829 13.8704 5.65044 13.008 5.34424 13.0859 4.58901 13.7242 4 14.5 4 15.3284 4 16 4.67157 16 5.5 16 6.04623 15.708 6.52427 15.2716 6.78656Z" class="svg-bg"/>
  <circle cx="11" cy="11" r="5" fill="#FDCA40"/>
  <path d="M12 7.5 10 8V12H12V7.5ZM12 13H10V15H12V13Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconMedConnectionsAddOnWarning is a generated icon component.
 */
let IconMedConnectionsAddOnWarning = IconMedConnectionsAddOnWarning_1 = class IconMedConnectionsAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconMedConnectionsAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedConnectionsAddOnWarning.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedConnectionsAddOnWarning = IconMedConnectionsAddOnWarning_1 = __decorate([
    customElement('zui-icon-med-connections-add-on-warning')
], IconMedConnectionsAddOnWarning);
export { IconMedConnectionsAddOnWarning };
